import contextCreator from "../contextCreator";
import EditListingReducer, { initialState } from "./editListing.reducer";

// eslint-disable-next-line react-hooks/rules-of-hooks
const [state, dispatch, provider] = contextCreator(
  EditListingReducer,
  initialState
);

export const useEditListingState = state;
export const useEditListingDispatch = dispatch;
export const EditListingProvider = provider;
